import React from 'react'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Grid,InputBase,TextField } from '@material-ui/core';
import { fade, makeStyles } from '@material-ui/core/styles';
import { Paper,   Divider, Icon } from '@material-ui/core';
import ExampleIntroduction from './IntroductionExamples';


class Examples extends React.Component{
    constructor(props){
        super(props)
        this.state={
            open:false,
            update:false
        }
        window.addEventListener('resize',this.handleSrceenResize)
    }
    //this is to handle srceen resize event
    handleSrceenResize=()=>{
        this.setState({
            update:(!this.state.update),
            open:false
        })
    }
    toggleDrawer=()=>{
        this.setState({open:(!this.state.open)})
    }
    //this is to get current visible page
    getCurrentPage=()=>{
        return <ExampleIntroduction/>
    }
    //this is mobile view 
    mobileView=()=>{
        let curPage=this.getCurrentPage();
        return<>
            <div style={{padding:'10px',marginTop:'20px'}}>
                    {curPage}
            </div>
         </>
    }

    //this is normal view
    normalView=()=>{
        let curPage=this.getCurrentPage();
        return<Grid container justify='center'>
            <Grid item md={10} lg={10}>
                <Paper style={{padding:'20px',margin:'20px',paddingLeft: '150px',paddingRight: '150px'}}>
                {curPage}
                </Paper>
            </Grid>
        </Grid>
    }

    render(){
        let content=null;
        if(window.screen.width<=768){
            content=this.mobileView();
        }else{
            content=this.normalView();
        }
        return <div style={{marginTop:'70px',color:'white',marginBottom:"20px"}}>
            {content}
        </div>; 


    }
}
export default Examples;